export enum FilterPeriod {
  CUSTOM = 'custom',
  LAST_30_DAYS = 'last-30-days',
  LAST_7_DAYS = 'last-7-days',
  LAST_90_DAYS = 'last-90-days',
  LIFETIME = 'lifetime',
  TODAY = 'today',
  YESTERDAY = 'yesterday',
}
